import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TOP_CHAPTERS } from '../data/chapters';
import AdBanner from '../components/AdBanner';

export default function FrontCover() {
  const navigate = useNavigate();

  return (
    <div className="page">
      <header className="nav-header">
        <h1 className="nav-title">Cheat 古典文法</h1>
      </header>
      <ul className="chapter-list">
        {TOP_CHAPTERS.map(ch => (
          <li key={ch.id} className="chapter-item top-chapter-item" onClick={() => navigate(`/chapter/${ch.id}`)}>
            <span>{ch.title}</span>
            <span className="chevron">›</span>
          </li>
        ))}
        <AdBanner />
      </ul>
    </div>
  );
}
